import * as React from "react";
import Svg, { Path } from "react-native-svg";

// Poly (T-shirt) bag outline — used for the plastic/poly-bag delivery indicator.
// `color` tints both the body and the handles so it can match the row text
// (#B45309) or sit on a coloured tag (white).
function PolyBagIcon({ color = "#B45309", width = 28, height = 28, ...props }) {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M6 8h12l1.27 9.78A2 2 0 0 1 17.29 20H6.71a2 2 0 0 1-1.98-2.22L6 8Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinejoin="round"
      />
      <Path
        d="M8.5 8V6.7C8.5 5.2 9.6 4 11 4l1 1.7L13 4c1.4 0 2.5 1.2 2.5 2.7V8"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

export default PolyBagIcon;
